module.exports = __webpack_public_path__ + "static/media/TikTok_Chin_iOS.8cddfd59.pdf";